"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionMapper = exports.networkMapper = exports.cardTypeMapper = void 0;
var enum_mapper_1 = require("../utils/enum-mapper");
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var social_sources_1 = require("@wix/wix-vod-constants/dist/video-cards/social-sources");
var positions_1 = require("@wix/wix-vod-constants/dist/video-cards/positions");
var globalTypes_1 = require("../private/generated/globalTypes");
exports.cardTypeMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.VideoCardType.CHANNEL] = types_1.VIDEO_CARD_TYPES.CHANNEL,
    _a[globalTypes_1.VideoCardType.VIDEO] = types_1.VIDEO_CARD_TYPES.VIDEO,
    _a[globalTypes_1.VideoCardType.CUSTOM] = types_1.VIDEO_CARD_TYPES.CUSTOM,
    _a[globalTypes_1.VideoCardType.PRODUCT] = types_1.VIDEO_CARD_TYPES.PRODUCT,
    _a[globalTypes_1.VideoCardType.RECENT_VIDEO] = types_1.VIDEO_CARD_TYPES.RECENT_VIDEO,
    _a[globalTypes_1.VideoCardType.SOCIAL] = types_1.VIDEO_CARD_TYPES.SOCIAL,
    _a));
exports.networkMapper = new enum_mapper_1.EnumMapper((_b = {},
    _b[globalTypes_1.VideoCardTargetExternalType.FACEBOOK] = social_sources_1.SOCIAL_SOURCES.FACEBOOK,
    _b[globalTypes_1.VideoCardTargetExternalType.TWITTER] = social_sources_1.SOCIAL_SOURCES.TWITTER,
    _b[globalTypes_1.VideoCardTargetExternalType.YOUTUBE] = social_sources_1.SOCIAL_SOURCES.YOUTUBE,
    _b));
exports.positionMapper = new enum_mapper_1.EnumMapper((_c = {},
    _c[globalTypes_1.VideoCardPosition.BOTTOM_LEFT] = positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_LEFT,
    _c[globalTypes_1.VideoCardPosition.BOTTOM_RIGHT] = positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT,
    _c[globalTypes_1.VideoCardPosition.TOP_LEFT] = null,
    _c[globalTypes_1.VideoCardPosition.TOP_RIGHT] = null,
    _c));
//# sourceMappingURL=video-cards.js.map